/**
 * Navigation utility for handling post-login redirects and module-specific routing
 */
import { isBakerModule } from './helpers/isBakerModule'

export const getDefaultRoute = (): string => {
  if (isBakerModule) {
    return '/products'
  }

  return '/shipments'
}
